import IpubConfirm from './src/main.js'
export default IpubConfirm
